import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Grid,
  Typography
} from '@material-ui/core';
import {
  Skeleton,
  Pagination
} from '@material-ui/lab';
import {makeStyles} from '@material-ui/styles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
  dateTime: {
    margin: 0,
    whiteSpace: 'nowrap'
  },
  comment: {
    maxWidth: 560,
    wordBreak: 'break-word'
  }
}));

const TableComponents = (props) => {
  const {
    rows,
    filter,
    pagination,
    isLoading,
    onChangeFilter
  } = props;
  const classes = useStyles();

  const handleChangePagination = (event, page) => {
    let newFilter = {...filter};
    newFilter.page = page;
    onChangeFilter(newFilter, true);
  }

  return (
    <>
      <Box mb={2}>
        <Grid container justify="flex-end">
          <Pagination
            page={filter.page}
            count={pagination.page || 1}
            onChange={handleChangePagination}
          />
        </Grid>
      </Box>

      <Box>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Пользователь</TableCell>
              <TableCell>Почта для связи</TableCell>
              <TableCell>Комментарий</TableCell>
              <TableCell align="right">Время обращения</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <RowLoading/>
            ) : (
              rows.map((row, idx) => (
                <TableRow key={`feedback-row-${row.id || idx}`}>
                  <TableCell>{row.username || '—'}</TableCell>
                  <TableCell>{row.email || '—'}</TableCell>
                  <TableCell>
                    <Typography className={classes.comment} component="span">
                      {row.text || '—'}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography className={classes.dateTime} component="div">
                      {moment(row.created).format('DD.MM.YYYY')}
                    </Typography>
                    <Typography className={classes.dateTime} component="div">
                      {moment(row.created).format('HH:mm')}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Box>

      <Box mt={2}>
        <Grid container justify="flex-end">
          <Pagination
            page={filter.page}
            count={pagination.page || 1}
            onChange={handleChangePagination}
          />
        </Grid>
      </Box>
    </>
  );
};

const RowLoading = () => (
  <>
    {[0, 1, 2, 3, 4].map((item) => (
      <TableRow key={`feedback-loading-${item}`}>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell><Skeleton/></TableCell>
        <TableCell align="right"><Skeleton/></TableCell>
      </TableRow>
    ))}
  </>
);

export default TableComponents;
